import { TextField } from '@mui/material';
import { ChangeEvent, FocusEvent, useEffect, useState } from 'react';

import { EventProps } from '@/models/Event';
import { QuestionProps } from '@/models/Question';
import { Translations } from '@/utils/translations/Translations';
import { stringHasValue } from '@/utils/stringUtil';

type EventNameProps = {
  translatedText: Translations;
  question: QuestionProps;
  eventInfo: EventProps;
  onEventChange: (updatedEvent: EventProps) => void;
  questionsEditable: boolean;
  selectOnFocus: (e: FocusEvent<HTMLInputElement>) => void;
};

export default function EventName({
  translatedText,
  question,
  eventInfo,
  onEventChange,
  questionsEditable,
  selectOnFocus,
}: EventNameProps) {
  const [eventName, setEventName] = useState<string | null>(eventInfo?.eventName ?? null);

  useEffect(() => {
    setEventName(eventInfo?.eventName ?? null);
  }, [eventInfo?.eventName]);

  useEffect(() => {
    if (eventName == null || eventName === eventInfo.eventName) return;

    onEventChange({
      ...eventInfo,
      eventName: eventName,
    });
  }, [eventName, eventInfo, onEventChange]);

  return (
    <TextField
      label={translatedText?.event?.eventName}
      required={question?.questionNeeded}
      disabled={!questionsEditable}
      value={eventName}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value;
        setEventName(v);
      }}
      onFocus={selectOnFocus}
      variant='outlined'
      error={!stringHasValue(eventName)}
      slotProps={{ htmlInput: { maxLength: 255 } }}
    />
  );
}
